import {
  format, getYear, max, endOfMonth,
} from 'date-fns';
import months from 'Shared/data/months';


export const modifyInvoices = (invoices, year, month) => {
  const monthIndex = months.findIndex((m) => m.value === month);
  const endOfMonthDate = endOfMonth(new Date(year, monthIndex));

  return invoices.map((invoice) => {
    if (!invoice.status && new Date(invoice.dueDate) < endOfMonthDate) {
      invoice.status = 'due';
    }
    return invoice;
  });
};

export const getDefaultYearAndMonth = (distinctLedgerDates) => {
  if (distinctLedgerDates.length <= 0) return [];
  const latestInvoice = max(distinctLedgerDates);
  return [getYear(latestInvoice), format(latestInvoice, 'MMMM')];
};

export const getFilterYears = (distinctLedgerDates) => {
  const currentYear = getYear(new Date());
  const distinctYears = [...new Set(distinctLedgerDates.map((d) => getYear(new Date(d))))];
  const minYear = (distinctYears.length > 0 ? Math.min(...distinctYears) : currentYear);

  const outputYears = [];
  for (let yearCounter = minYear; yearCounter <= currentYear; yearCounter += 1) {
    outputYears.unshift({
      label: yearCounter.toString(),
      value: yearCounter,
      disabled: !distinctYears.includes(yearCounter),
    });
  }
  return outputYears;
};

export const getFilterMonths = (distinctLedgerDates, year, monthsObject) => {
  const distinctMonths = [...new Set(distinctLedgerDates.filter((d) => getYear(new Date(d)) === year).map((d) => format(d, 'MMMM')))];
  return monthsObject.map((m) => ({
    label: m.label,
    value: m.value,
    disabled: !distinctMonths.includes(m.value),
  }));
};
